import { EAnalyticsEvents } from '@/_analytic/_types';
import { sendAnalyticsEvent } from '@/_analytic/send-analytics-event';
import { TArticlePrintClickEventParams } from './_types';

export const articlePrintClickEvent = (
  params: TArticlePrintClickEventParams,
) => {
  sendAnalyticsEvent({
    name: EAnalyticsEvents.ARTICLE_PRINT_CLICK,
    params,
  });
};
